import api from "../api";

export const actions = {
    delete: {
        method: 'DELETE',
        icon: 'delete'
    },
    update: {
        method: 'PUT',
        icon: 'edit',
    },
    resend: {
        method: 'POST',
        icon: 'redo'
    }
};
function getUuids(item){
    console.log("item", item);
    for (let [index, value] of Object.entries(item)) {
        if(Array.isArray(value)){
            value = value.map((i)=>{
                if(typeof i === "object"){
                    return i.uuid;
                }
                else{
                    return i
                }
            })
        }
        else if (value!==null && typeof value === "object" && typeof value.uuid !== "undefined" ){
            value = value.uuid
        }
        item[index] = value;
    }
    return item;
}
export const _applyAction = function(actionKey, data, href=null){
    return new Promise((resolve, reject)=>{
        let url = href;
        console.log(data);
        const action = actions[actionKey];
        if(Array.isArray(data)){
                let responses = [];
                data.every((item, index)=>{
                    if(href===null){
                        url = item._links[actionKey].href;
                    }
                    item = getUuids(item);
                    return api({
                        method: action.method,
                        url: url,
                        data: item
                    }).then(response => {
                            responses.push(response.data);
                            console.log(response.data);
                            if(index===data.length-1){
                                console.log("DONE");
                                resolve(responses);
                            }
                            return true;
                        }).catch(error =>{
                            console.error(error.response);
                            reject(error.response.data.error.exception);
                            return false;
                    });
                });
        }
        else{
            if(href===null){
                url = data._links[actionKey].href;
            }
            data = getUuids(data);
            api({
                method: action.method,
                url: url,
                data: data
            }).then(response => {
                console.log(response);
                resolve(response.data)
            }).catch(error =>{
                console.error(error);
                reject(error.response);
                return false;
            });
        }
    });
};
